import companyImg1 from "assets/images/companies/img-1.png";
import companyImg2 from "assets/images/companies/img-2.png";
import companyImg3 from "assets/images/companies/img-3.png";
import companyImg4 from "assets/images/companies/img-4.png";
import companyImg5 from "assets/images/companies/img-5.png";
import companyImg6 from "assets/images/companies/img-6.png";
import companyImg7 from "assets/images/companies/img-7.png";
// import companyImg8 from "@assets/images/companies/img-8.png";

//SellerList img
import img1 from "assets/images/companies/img-1.png";
import img5 from "assets/images/companies/img-5.png";
import img2 from "assets/images/companies/img-2.png";
import img6 from "assets/images/companies/img-6.png";
import img3 from "assets/images/companies/img-3.png";
import img7 from "assets/images/companies/img-7.png";

const sellerList = [
    {
        id: 1,
        sellerName: "Alfred Hurst",
        itemStock: "245",
        balance: "$748.32k",
        email: "alfredH@steex.com",
        phone: "415-778-3654",
        createDate: "18 Dec, 2018",
        status: "Inactive"
    },
    {
        id: 2,
        sellerName: "Tommy Carey",
        itemStock: "3982",
        balance: "$1452.74k",
        email: "careytommy@steex.com",
        phone: "963-012-7495",
        createDate: "02 Jan, 2023",
        status: "Active"
    },
    {
        id: 3,
        sellerName: "Cassius Brock",
        itemStock: "1571",
        balance: "$341.81k",
        email: "brock@steex.com",
        phone: "415-778-3654",
        createDate: "24 Nov, 2022",
        status: "Active"
    },
    {
        id: 4,
        sellerName: "Camilla Winters",
        itemStock: "1873",
        balance: "$671.00k",
        email: "camilla@steex.com",
        phone: "013-789-9876",
        createDate: "12 Jan, 2023",
        status: "Inactive"
    },
    {
        id: 5,
        sellerName: "Gabrielle Holden",
        itemStock: "2268",
        balance: "$803.11k",
        email: "gabrielle@steex.com",
        phone: "032-012-3654",
        createDate: "17 Nov, 2022",
        status: "Active"
    },
    {
        id: 6,
        sellerName: "Kristina Hooper",
        itemStock: "976",
        balance: "$203.65k",
        email: "kristina@steex.com",
        phone: "654-321-0789",
        createDate: "04 Oct, 2020",
        status: "Inactive"
    },
    {
        id: 7,
        sellerName: "Jacques Leon",
        itemStock: "2870",
        balance: "$2145.20k",
        email: "jacques@steex.com",
        phone: "094-951-3576",
        createDate: "07 Feb, 2015",
        status: "Active"
    },
    {
        id: 8,
        sellerName: "Theresa Crawford",
        itemStock: "2504",
        balance: "$3468.41k",
        email: "crawford@steex.com",
        phone: "364-953-0764",
        createDate: "28 Oct, 2014",
        status: "Active"
    },
    {
        id: 9,
        sellerName: "Alina Holland",
        itemStock: "703",
        balance: "$351.91k",
        email: "hollandalina@steex.com",
        phone: "275-754-9658",
        createDate: "16 Aug, 2016",
        status: "Active"
    },
    {
        id: 10,
        sellerName: "Edward Rogers",
        itemStock: "2419",
        balance: "$1876.02k",
        email: "edwardro@steex.com",
        phone: "546-010-0739",
        createDate: "25 Nov, 2021",
        status: "Inactive"
    },
    {
        id: 11,
        sellerName: "Camilla Winters",
        itemStock: "1873",
        balance: "$671.00k",
        email: "camilla@steex.com",
        phone: "013-789-9876",
        createDate: "12 Jan, 2023",
        status: "Inactive"
    }
]

const sellerGrid = [
    {
        id: 1,
        sellerName: "Zibra Fashion Ltd",
        companyLogo: companyImg5,
        verified: true,
        webUrl: "www.zibrafashion.com",
        stock: "2587",
        revenue: "438.36"
    }, {
        id: 2,
        sellerName: "Terry & Jerry",
        companyLogo: companyImg5,
        verified: false,
        webUrl: "www.terry&jerry.com",
        stock: "850",
        revenue: "213.52"
    }, {
        id: 3,
        sellerName: "Themesbrand",
        companyLogo: companyImg1,
        verified: false,
        webUrl: "www.themesbrand.com",
        stock: "1546",
        revenue: "383.50"
    }, {
        id: 4,
        sellerName: "Digital Galaxy",
        companyLogo: companyImg4,
        verified: true,
        webUrl: "www.digitalgalaxy.com",
        stock: "241",
        revenue: "184.20"
    }, {
        id: 5,
        sellerName: "Rotic Fashion",
        companyLogo: companyImg3,
        verified: false,
        webUrl: "www.roticfashion.com",
        stock: "654",
        revenue: "224.10"
    }, {
        id: 6,
        sellerName: "RND Fashion",
        companyLogo: companyImg2,
        verified: true,
        webUrl: "www.rndfashion.com",
        stock: "150",
        revenue: "180.62"
    }, {
        id: 7,
        sellerName: "Jorce Medicines",
        companyLogo: companyImg7,
        verified: false,
        webUrl: "www.jorcemedicines.com",
        stock: "540",
        revenue: "947.33"
    }, {
        id: 8,
        sellerName: "Pich Hub",
        companyLogo: companyImg6,
        verified: false,
        webUrl: "www.pichhub.com",
        stock: "874",
        revenue: "365.87"
    }, {
        id: 9,
        sellerName: "Chase Pitkin",
        companyLogo: companyImg5,
        verified: true,
        webUrl: "-",
        stock: "2587",
        revenue: "438.36"
    }, {
        id: 10,
        sellerName: "Star Merchant Services",
        companyLogo: companyImg4,
        verified: false,
        webUrl: "www.starmerchant.com",
        stock: "850",
        revenue: "213.52"
    }
]


const sellingdata = [
    {
        id: 1,
        img: { priview: img7, formattedSize: "7.66 KB", path: "img-7.png", size: '6006' },
        imgalt: "img-7.png",
        name: "Pich Hub",
        seller: "Lenna Labadie",
        email: "lennalabadie@dayrep.com",
        phone: "+(253) 12345 67890",
        stock: "451",
        revenue: "253.32",
        chartColor: 'danger',
        chartdata: [12, 14, 2, 47, 42, 15, 47, 75, 65, 19, 14]
    },
    {
        id: 2,
        img: { priview: img5, formattedSize: "7.66 KB", path: "img-5.png", size: '6006' },
        imgalt: "img-5.png",
        name: "Jorce Medicines",
        seller: "Dallin Schowalter",
        email: "dallinschowalter@rhyta.com",
        phone: "+(152) 32165 49873",
        stock: "1163",
        revenue: "992.14",
        chartColor: 'success',
        chartdata: [12, 14, 2, 47, 42, 15, 35, 75, 20, 67, 89]
    },
    {
        id: 3,
        img: { priview: img2, formattedSize: "7.66 KB", path: "img-2.png", size: '6006' },
        imgalt: "img-2.png",
        name: "Rotic Fashion",
        seller: "Alvina Smitham",
        email: "alvinasmitham@dayrep.com",
        phone: "+(231) 14562 32165",
        stock: "1023",
        revenue: "954.08",
        chartColor: 'success',
        chartdata: [45, 20, 8, 42, 30, 5, 35, 79, 22, 54, 64]
    },
    {
        id: 4,
        img: { priview: img6, formattedSize: "7.66 KB", path: "img-6.png", size: '6006' },
        imgalt: "img-6.png",
        name: "Terry & Jerry",
        seller: "Dallin Schowalter",
        email: "dallinschowalter@jourrapide.com",
        phone: "+(44) 98765 32104",
        stock: "357",
        revenue: "346.35",
        chartColor: 'success',
        chartdata: [26, 15, 48, 12, 47, 19, 35, 19, 85, 68, 50]
    },
    {
        id: 5,
        img: { priview: img3, formattedSize: "7.66 KB", path: "img-3.png", size: '6006' },
        imgalt: "img-3.png",
        name: "Themesbrand",
        seller: "Kenyon Nienow",
        email: "kenyonnienow@dayrep.com",
        phone: "+(251) 25874 13690",
        stock: "841",
        revenue: "654.78",
        chartColor: 'danger',
        chartdata: [60, 67, 12, 49, 6, 78, 63, 51, 33, 8, 16]
    },
    {
        id: 6,
        img: { priview: img2, formattedSize: "7.66 KB", path: "img-2.png", size: '6006' },
        imgalt: "img-2.png",
        name: "Brand Infosys",
        seller: "Alexandrea Jacobi",
        email: "alexandreajacobi@jourrapide.com",
        phone: "+(92) 67890 12345",
        stock: "395",
        revenue: "153.84",
        chartColor: 'success',
        chartdata: [78, 63, 51, 33, 8, 16, 60, 67, 12, 49,]
    },
    {
        id: 7,
        img: { priview: img7, formattedSize: "7.66 KB", path: "img-7.png", size: '6006' },
        imgalt: "img-7.png",
        name: "Pich Fashion",
        seller: "Jaylon McClure",
        email: "jaylonmcclure@armyspy.com",
        phone: "+(62) 35791 15935",
        stock: "792",
        revenue: "357.44",
        chartColor: 'success',
        chartdata: [15, 35, 75, 20, 67, 8, 42, 30, 5, 35]
    },
    {
        id: 8,
        img: { priview: img1, formattedSize: "7.66 KB", path: "img-1.png", size: '6006' },
        imgalt: "img-1.png",
        name: "Zibra Fashion",
        seller: "Lenna Labadie",
        email: "lennalabadie@dayrep.com",
        phone: "+(120) 15935 32165",
        stock: "451",
        revenue: "253.32",
        chartColor: 'danger',
        chartdata: [45, 32, 68, 55, 36, 10, 48, 25, 74, 54]
    }
];

const portfoliodata = [
    {
        id: 1,
        title: "Orders",
        num: "7,585",
        color: "muted"
    },
    {
        id: 2,
        title: "Earnings",
        num: "$750.36M",
        color: "muted"
    },
    {
        id: 3,
        title: "Refunds",
        num: 328,
        color: "muted"
    },
    {
        id: 4,
        title: "Conversation Ratio",
        num: "18.92 %",
        color: "text-success"
    },
]

export { sellerList, sellerGrid, sellingdata, portfoliodata }
